import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environmentURL } from '../../../environments/environment';
import { AuthSessionService } from '../auth/auth-session.service';

/** Interceptor que adjunta Bearer token de cliente o JWT de sesión. */
export const apiAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(AuthSessionService);
  const jwt = session.getJwt();

  // Comentario: si hay JWT de usuario, se usa para APIs autenticadas.
  if (jwt) {
    return next(
      req.clone({
        setHeaders: {
          Authorization: `Bearer ${jwt}`,
        },
      }),
    );
  }

  // Comentario: rutas pre-auth usan el token fijo del portal (MobileApp1039).
  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${environmentURL.portalAppClientToken}`,
      },
    }),
  );
};
